import { Site } from '../constants';
import { Deserializable } from '../interfaces';

export class UpdateClient implements Deserializable {
  idSitio: number | null;
  idUsuarioValor: number | null;
  idUsuario: number | null;
  nombre: string | null;
  Foto: string;
  contrasena: string;
  correoElectronico: string | null;
  telefono: string | null;
  idioma: string | null;
  claveTelefono: string;

  constructor() {
    this.idSitio = Site.siteId;
    this.idUsuarioValor = null;
    this.Foto = '';
    this.claveTelefono = '';
    this.idUsuario = null;
    this.nombre = null;
    this.contrasena = '';
    this.correoElectronico = null;
    this.telefono = null;
    this.idioma = null;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
